var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGoogle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_GOOGLE",
    x: "0px",
    y: "0px",
    width: "164.331px",
    height: "54.095px",
    viewBox: "0 0 164.331 54.095",
    enableBackground: "new 0 0 164.331 54.095",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C5",
    d: "M70.324,28.467c0,7.783-6.088,13.518-13.561,13.518c-7.471,0-13.56-5.734-13.56-13.518 c0-7.838,6.089-13.517,13.56-13.517C64.236,14.95,70.324,20.629,70.324,28.467z M64.388,28.467c0-4.862-3.527-8.19-7.624-8.19 c-4.096,0-7.623,3.328-7.623,8.19c0,4.814,3.527,8.191,7.623,8.191C60.86,36.658,64.388,33.275,64.388,28.467z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C5",
    d: "M99.576,28.467c0,7.783-6.087,13.518-13.559,13.518c-7.473,0-13.561-5.734-13.561-13.518 c0-7.831,6.088-13.517,13.561-13.517C93.489,14.95,99.576,20.629,99.576,28.467z M93.642,28.467c0-4.862-3.528-8.19-7.624-8.19 c-4.097,0-7.624,3.328-7.624,8.19c0,4.814,3.527,8.191,7.624,8.191C90.113,36.658,93.642,33.275,93.642,28.467z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C5",
    d: "M127.611,15.767v24.269c0,9.982-5.887,14.06-12.846,14.06c-6.552,0-10.494-4.383-11.982-7.965l5.168-2.152 c0.92,2.2,3.176,4.797,6.808,4.797c4.454,0,7.216-2.749,7.216-7.923v-1.944h-0.207c-1.328,1.64-3.889,3.071-7.119,3.071 c-6.758,0-12.949-5.888-12.949-13.462c0-7.631,6.191-13.566,12.949-13.566c3.225,0,5.785,1.433,7.119,3.022h0.207v-2.2h5.637 V15.767z M122.395,28.517c0-4.761-3.174-8.24-7.215-8.24c-4.096,0-7.527,3.479-7.527,8.24c0,4.711,3.432,8.142,7.527,8.142 C119.221,36.658,122.395,33.228,122.395,28.517z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C5",
    d: "M136.906,1.542v39.613h-5.79V1.542H136.906z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C5",
    d: "M159.468,32.917l4.608,3.071c-1.487,2.199-5.072,5.99-11.264,5.99c-7.679,0-13.414-5.937-13.414-13.518 c0-8.038,5.783-13.517,12.75-13.517c7.014,0,10.445,5.581,11.566,8.6l0.616,1.535l-18.071,7.483 c1.385,2.713,3.536,4.096,6.553,4.096C155.836,36.658,157.932,35.171,159.468,32.917L159.468,32.917z M145.286,28.053l12.079-5.015 c-0.665-1.688-2.663-2.866-5.016-2.866C149.333,20.172,145.134,22.837,145.286,28.053z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C5",
    d: "M21.288,24.951v-5.735h19.325c0.189,1,0.288,2.182,0.288,3.463c0,4.302-1.177,9.622-4.968,13.412 c-3.688,3.84-8.398,5.888-14.64,5.888C9.728,41.979,0,32.558,0,20.989C0,9.423,9.728,0,21.294,0c6.399,0,10.958,2.51,14.383,5.783 L31.63,9.83c-2.455-2.304-5.783-4.095-10.342-4.095c-8.446,0-15.054,6.808-15.054,15.254s6.607,15.254,15.054,15.254 c5.478,0,8.6-2.199,10.599-4.198c1.621-1.621,2.688-3.938,3.107-7.101L21.288,24.951z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/google.d1b338bb.svg";
export { ForwardRef as ReactComponent };